module.exports = __webpack_public_path__ + "img/17_69.5f4a34ed.png";